// src/components/DiscountsTab.jsx
import DiscountCard from './DiscountCard';

export default function DiscountsTab({ kind, businessId, items, setItems, errorsByIndex, onDelete, currencyMeta }) {
  function addNew() {
    setItems(prev => [
      {
        id: null,
        name: '',
        percentage: true,
        value: 0,
        start_date: '',
        end_date: '',
        min_spend: 0,
        max_client_uses: 1,
        max_total_uses: 0,
        coupon: '',
        new_customer_only: false,
        exclusive: false,
        apply_all: false,
        items: [],
        // NEW product perks shape
        free_products: [],
        discounted_products: [], // [{ product_id, percent }]
        _dirty: true,
      },
      ...prev,
    ]);
  }

  function updateAt(index, next) {
    setItems(prev => prev.map((it, i) => (i === index ? { ...next, _dirty: true } : it)));
  }

  const maxByKind = kind === 'reservations' ? 20 : 50;
  const count = items?.length || 0;

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <button
          onClick={addNew}
          disabled={count >= maxByKind}
          className="rounded bg-green-600 px-4 py-2 text-white hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          + Add discount rule
        </button>
        <span className="text-xs text-gray-500">{count}/{maxByKind}</span>
      </div>

      {items.length === 0 ? (
        <p className="text-sm text-gray-500">No discount rules yet.</p>
      ) : (
        items.map((d, idx) => (
          <DiscountCard
            key={d.id ?? `new-${idx}`}
            form={d}
            onChange={next => updateAt(idx, next)}
            kind={kind}
            businessId={businessId}
            errors={errorsByIndex?.[idx] || {}}
            onDelete={() => onDelete(d, idx)}
            currencyMeta={currencyMeta}
          />
        ))
      )}
    </div>
  );
}
